export default __webpack_public_path__ + "static/media/ship.e1f240a3.png";